import { css } from 'styled-components';
import { breakpoints, colors } from '../../style-utilities/variables';
export default css`
  .share {
    display: none;
  }
`;
